<div *ngIf="timelinePage && timelinePage.timelines?.length > 0" class="container-fluid mb-4">
  <xm-loader [showLoader]="showLoader"></xm-loader>
  <div *ngIf="showTimelineHeader" class="header text-center">
    <h3 class="title text-muted mb-4">{{'xm-timeline.timeline.title'|translate}}</h3>
  </div>

  <xm-loader [showLoader]="showLoader"></xm-loader>

  <div class="d-flex justify-content-center mb-2" *ngIf="filter?.states?.length">
    <div *ngIf="filter?.states?.length" class="xm-button-group mb-3" style="margin-right: 20px">
      <button (click)="applyFastSearch('')"
              [class.active]="!currentSearch"
              class="size-sm"
              color="primary"
              mat-flat-button>
        {{'global.all'|translate}}
      </button>

      <button (click)="applyFastSearch(item.state)"
              *ngFor="let item of filter.states"
              [class.active]="currentSearch === item.state"
              class="size-sm"
              color="primary"
              mat-flat-button>
        {{item.name}}
      </button>
    </div>
  </div>
  <div>

    <div style="display: flex; flex-direction: row; align-items: center;">
      <div *ngIf="filter?.states?.length" class="xm-button-group mb-3" style="margin-right: 20px">
        <button (click)="applyFastSearch('')"
                [class.active]="!currentSearch"
                class="size-sm"
                color="primary"
                mat-flat-button>
          {{'global.all'|translate}}
        </button>

        <button (click)="applyFastSearch(item.state)"
                *ngFor="let item of filter.states"
                [class.active]="currentSearch === item.state"
                class="size-sm"
                color="primary"
                mat-flat-button>
          {{item.name}}
        </button>
      </div>
    </div>

    <div class="xm-timeline">
      <div class="row flex-nowrap mb-5" *ngFor="let tl of timelinePage.timelines">
        <div class="col-auto">
          <button class="timeline-point" mat-fab color="primary">
            <mat-icon>history</mat-icon>
          </button>
        </div>

        <div class="col ps-4">
          <mat-card class="history-item">
            <h6 class="mb-3">
              {{tl.operationName}} {{timeAgo(tl.startDate)}}
              <span>{{'xm-timeline.timeline.by'|translate}}</span>
              {{tl.login}}
            </h6>

            <mat-chip-listbox class="timeline-chips-list">
              <mat-chip class="success" *ngIf="tl.httpStatusCode < 300">
                {{'xm-timeline.timeline.success'|translate}}
              </mat-chip>
              <mat-chip class="danger" *ngIf="tl.httpStatusCode >= 300">
                {{'xm-timeline.timeline.error'|translate}}
              </mat-chip>
              <mat-chip *ngIf="tl.startDate">{{tl.startDate | date:'dd/MM/yy HH:mm'}}</mat-chip>
              <mat-chip *ngIf="tl.browser">{{tl.browser}}</mat-chip>
              <mat-chip *ngIf="tl.opSystem">{{tl.opSystem}}</mat-chip>
              <mat-chip *ngIf="tl.requestHeaders['x-forwarded-for']">
                {{tl.requestHeaders['x-forwarded-for']}}
              </mat-chip>
            </mat-chip-listbox>

            <div *ngIf="!template && (tl.requestBody || tl.responseBody)" class="timeline-body">
              <span>{{tl.requestBody}}</span>&nbsp;
              <span>{{tl.responseBody}}</span>
            </div>

            <div *ngIf="template" [innerHTML]="template(tl)"
                 class="timeline-body">
            </div>
          </mat-card>
        </div>
      </div>

      <button (click)="onNextPage(timelinePage.next)"
              *ngIf="timelinePage.next"
              [disabled]="showLoader"
              mat-raised-button
              color="primary"
              type="submit">
        <span>{{'xm-timeline.timeline.more'|translate}}</span>
      </button>
    </div>
  </div>
</div>
